import { Modal, Space, Card, Row, Col, Flex, Button, Typography } from "antd";
import { useTranslation } from "react-i18next";
import { ReactComponent as PDFIcon } from "../../../../assets/icon/pdfIcon.svg";
import { ReactComponent as ExcelIcon } from "../../../../assets/icon/excelIcon.svg";
import { ReactComponent as DownloadIcon } from "../../../../assets/icon/downloadIcon.svg";

import {
    FileImageOutlined,
    FilePdfOutlined,
    FileExcelOutlined,
    FileWordOutlined,
    FileTextOutlined,
    FileUnknownOutlined,
    DownloadOutlined,
    EyeOutlined,
} from "@ant-design/icons";
import { Image } from "antd/lib";

function FilesModal({
    isDownloading = false,
    handleOk = () => { },
    exportWorkingTimeGroupReport = () => { },
    exportExpenseSummary = () => { },
    setFileHandle = () => { },
    fileHandle = { open: false, fileList: [] },
    name = ""
}) {
    const { t, i18n } = useTranslation();
    console.log("fileHandle", fileHandle);

    const getExtensionFromMimeType = (mimeType) => {
        const map = {
            "image/jpeg": "jpg",
            "image/png": "png",
            "image/gif": "gif",
            "image/webp": "webp",
            "application/pdf": "pdf",
            "application/msword": "doc",
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document": "docx",
            "application/vnd.ms-excel": "xls",
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": "xlsx",
            "text/plain": "txt",
        };

        return map[mimeType] || "bin";
    };

    const getFileInfo = (mimeType) => {
        if (!mimeType) {
            return {
                icon: <FileUnknownOutlined style={{ fontSize: 32 }} />,
                type: "Unknown File",
            };
        }

        if (mimeType.startsWith("image/")) {
            return {
                icon: <FileImageOutlined style={{ fontSize: 32, color: "#52C41A" }} />,
                type: "Image",
            };
        }

        if (mimeType === "application/pdf") {
            return {
                icon: <FilePdfOutlined style={{ fontSize: 32, color: "#FF4D4F" }} />,
                type: "PDF",
            };
        }

        if (
            mimeType ===
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
            mimeType === "application/vnd.ms-excel"
        ) {
            return {
                icon: <FileExcelOutlined style={{ fontSize: 32, color: "#52C41A" }} />,
                type: "Excel",
            };
        }

        if (
            mimeType ===
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ||
            mimeType === "application/msword"
        ) {
            return {
                icon: <FileWordOutlined style={{ fontSize: 32, color: "#1677FF" }} />,
                type: "Word",
            };
        }

        if (mimeType.startsWith("text/")) {
            return {
                icon: <FileTextOutlined style={{ fontSize: 32 }} />,
                type: "Text",
            };
        }

        return {
            icon: <FileUnknownOutlined style={{ fontSize: 32 }} />,
            type: mimeType,
        };
    };


    return (
        <Modal
            title={<span color="#42526D">{t("report.label.download_file")}</span>}
            destroyOnClose
            open={fileHandle.open}
            footer={null}
            closable={false}
            maskClosable={false}
        >
            <Space direction="vertical" size={24} style={{ width: "100%" }}>
                <span style={{ fontSize: "14px", color: "#667085" }}>
                    {t("report.modal.description")}
                </span>
                {fileHandle?.fileList?.map((file, index) => {
                    const fileInfo = getFileInfo(file.mimeType);
                    const extension = getExtensionFromMimeType(file.mimeType);
                    const fileName = `file_${index + 1}.${extension}`;
                    const fileUrl = `data:${file.mimeType};base64,${file.fileByte}`;
                    console.log('fileUrl', fileUrl);

                    return (
                        <Card
                            key={file.path ?? index}
                            style={{
                                backgroundColor: "#F5F6F7",
                                border: "1px solid #E4E7EC",
                                borderRadius: 12,
                                marginBottom: 12,
                            }}
                            styles={{ body: { padding: 16 } }}
                        >
                            <Row align="middle">
                                <Col span={16}>
                                    <Flex gap={16} align="center">
                                        {file.mimeType?.startsWith("image/") ? (
                                            <Image
                                                src={fileUrl}
                                                width={48}
                                                height={48}
                                                preview
                                                style={{
                                                    borderRadius: 8,
                                                    objectFit: "cover",
                                                }}
                                            />
                                        ) : (
                                            fileInfo.icon
                                        )}

                                        <Flex vertical>
                                            <Typography.Text strong>{fileName}</Typography.Text>

                                            <Typography.Text type="secondary">
                                                {fileInfo.type}
                                            </Typography.Text>

                                            <Typography.Text type="secondary">
                                                {(file.size / 1024).toFixed(2)} KB
                                            </Typography.Text>
                                        </Flex>
                                    </Flex>
                                </Col>

                                <Col span={8} style={{ textAlign: "right" }}>
                                    <Button
                                        icon={
                                            file.mimeType === "application/pdf"
                                                ? <EyeOutlined />
                                                : <DownloadOutlined />
                                        }
                                        onClick={() => {
                                            if (file.mimeType === "application/pdf") {
                                                const [header, base64] = fileUrl.split(",");

                                                const byteCharacters = atob(base64);
                                                const byteNumbers = new Array(byteCharacters.length);

                                                for (let i = 0; i < byteCharacters.length; i++) {
                                                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                                                }

                                                const byteArray = new Uint8Array(byteNumbers);
                                                const blob = new Blob([byteArray], {
                                                    type: "application/pdf",
                                                });

                                                const blobUrl = URL.createObjectURL(blob);

                                                window.open(blobUrl, "_blank");

                                                // cleanup หลังจาก browser โหลด URL แล้ว
                                                setTimeout(() => URL.revokeObjectURL(blobUrl), 1000);
                                            } else {
                                                const a = document.createElement("a");
                                                a.href = fileUrl;
                                                a.download = fileName;
                                                a.click();
                                            }
                                        }}
                                    >
                                        {file.mimeType === "application/pdf" ? "Preview" : "Download"}
                                    </Button>
                                </Col>
                            </Row>
                        </Card>
                    );
                })}


                <Row justify={"end"}>
                    <Button style={{ borderRadius: "8px", height: "40px" }} type="default" onClick={() => {
                        setFileHandle({
                            open: false,
                            fileList: []
                        })
                    }}>
                        <span style={{ fontWeight: "bold", color: "#344054" }}>{t("common.cancel").toUpperCase()}</span>
                    </Button>
                </Row>
            </Space>
        </Modal>
    )
}

export default FilesModal;